import { makeStyles } from '@mui/styles';

export const useSelectForDistanceStyles = makeStyles({
  root: {
    height: 70,
    marginTop: 5,
  },
});
